<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L3HQVx/tc-custom/9781617451249.jpg?1731010317353" alt="This image is the cover for the book Double Vision Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Double Vision Quilts
      </h1>
      <p class="bookDescription body article font2">
        <p>Fool the eye with dynamic quilts that are easy to sew  Learn how to turn squares and rectangles into circles and ovals with no curved piecing—it’s easy! Use innovative layering, playful patterns, and delightful color choices to create 11 mind-bending quilt projects that’ll have you seeing double. The best-selling author of Strips ‘n Curves shares three simple construction methods. With something for every type of quilter, the endless possibilities of this collection will inspire you to see quilting in a whole new light.  • No curved piecing! Add three easy techniques to your repertoire for no-stress circles and ovals • 11 opulent quilts with dazzling primary and secondary designs  • Learn layering, texture, color, and pattern with the best-selling author of Strips ‘n Curves</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louisa L. Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ff2f347